import { applyMiddleware, combineReducers, compose, createStore } from "redux";
import usuarioReducer from "./reducers/usuarioReducer";
import serviciosReducer from "./reducers/serviciosReducer";
import comunicacionesReducer from "./reducers/comunicacionesReducer";
import miCuentaReducer from "./reducers/miCuentaReducer";
import relacionseReducer from "./reducers/relacionesReducer";
import administracionReducer from "./reducers/administracionReducer";
import misDocumentosReducer from "./reducers/misDocumentosReducer";
import loadingReducer from "./reducers/loadingReducer";
import thunk from "redux-thunk";

export interface RootState {
  usuario: any;
  servicios: any;
  comunicaciones: any;
  miCuenta: any;
  relaciones: any;
  administracion: any;
  documentos: any;
  loading: any;
}

const rootReducer = combineReducers({
  usuario: usuarioReducer,
  servicios: serviciosReducer,
  comunicaciones: comunicacionesReducer,
  miCuenta: miCuentaReducer,
  relaciones: relacionseReducer,
  administracion: administracionReducer,
  documentos: misDocumentosReducer,
  loading: loadingReducer,
});

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunk))
);
